import { createContext, useEffect, useState } from 'react';
import { atom, createStore, useAtom } from 'jotai';

/**
 * Is the campaign Modal open?
 */
const campaignModalStatusAtom = atom(false);
campaignModalStatusAtom.debugLabel = 'campaignModalStatusAtom';
/**
 * Should the modal success be shown?
 */
const campaignModalSuccessAtom = atom(false);
campaignModalSuccessAtom.debugLabel = 'campaignModalSuccessAtom';

/**
 * What is the cart type to make the donation?
 */
const campaignModalCartTypeAtom = atom<'donation' | 'pledge'>('donation');
campaignModalCartTypeAtom.debugLabel = 'campaignModalCartTypeAtom';

const Context = createContext<ReturnType<typeof createStore> | undefined>(undefined);
// TODO: Update the provider and scope the atoms to use this specific provider.
const CampaignModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [store] = useState(() => createStore());
  return <Context.Provider value={store}>{children}</Context.Provider>;
};
/**
 * Used for handle the donation modal
 */
const useCampaignDonationModal = ({ resetOnDismount = false } = {}) => {
  const [isModalOpen, setIsModalOpen] = useAtom(campaignModalStatusAtom);
  const [isSuccess, setIsSuccess] = useAtom(campaignModalSuccessAtom);
  const [cartType, setCartType] = useAtom(campaignModalCartTypeAtom);

  useEffect(() => {
    return () => {
      resetOnDismount && setIsSuccess(false);
      resetOnDismount && setCartType('donation');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Setters are stable!
  }, [resetOnDismount]);

  return {
    isSuccess,
    setIsSuccess,
    isModalOpen,
    setIsModalOpen,
    cartType,
    setCartType,
  };
};

export { CampaignModalProvider, useCampaignDonationModal };
